import { render, staticRenderFns } from "./PosHeader.vue?vue&type=template&id=edce9e2e&scoped=true"
import script from "./PosHeader.vue?vue&type=script&lang=js"
export * from "./PosHeader.vue?vue&type=script&lang=js"
import style0 from "./PosHeader.vue?vue&type=style&index=0&id=edce9e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edce9e2e",
  null
  
)

export default component.exports